module.exports = __webpack_public_path__ + "static/fourpcdinosaurmain-f9ddd5f13a5b419aa6ef6641839e75fe.jpeg";